import "../scss/style.scss";
import "./ecommerce/index";

import sal from "sal.js";

// Initialize Sal.js
// You can pass an options object to sal() if needed, e.g., sal({ threshold: 0.5, once: false })
// Refer to the Sal.js documentation for more options: https://mciastek.github.io/sal/
sal();

import "./parts/header"; // Import header JavaScript
import "./templates/home";
import "./templates/subpage";
import "./templates/singlePost";
import "./templates/medyaMerkezi";
import "./parts/footer";
